<template>
  <qb-sidebar
    :name="name"
    :title="data.clientName | upperCase"
    :bgColor="data.statusColor"
    textColor="#fff"
    size="lg"
    :loading="loading"
    @open="open"
  >
    <template v-slot:header>
      <vs-row vs-justify="center" class="px-4 mb-4 f-14">
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $t('expense') | capitalize }} ID :
            {{ data.expenseId }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $t('serie') | capitalize }} :
            {{ data.serie }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $t('folio') | capitalize }} :
            {{ data.folio }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $t('date') | capitalize }} :
            {{ formatDate(data.receivedDate, 'MM/DD/YYYY HH:mm:ss') }}
          </p>
        </vs-col>
      </vs-row>
    </template>
    <vs-row vs-justify="start" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3">
        <dashboard-pdf-viewer
          class="w-full"
          :files="files"
          :title="data.clientName"
        />
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-w="12">
        <span class="f-bold"> {{ $t('client') | capitalize }} : </span>
        <span class="ml-2">
          {{ data.clientName | capitalize }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="12">
        <span class="f-bold"> {{ $t('pay_date') | capitalize }} : </span>
        <span class="ml-2">
          {{ formatDate(data.paydate, 'MM/DD/YYYY HH:mm:ss') }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
        <span class="f-bold"> {{ $t('account_number') | capitalize }} : </span>
        <span class="ml-2">
          {{ data.accountNumber }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
        <span class="f-bold"> {{ $t('category') | capitalize }} : </span>
        <span class="ml-2">
          {{ data.categoryName | capitalize }}
        </span>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="center" class="p-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
        <vs-row vs-justify="center" class="f-14">
          <vs-col vs-type="flex" vs-w="12">
            <span class="f-bold"> {{ data.companyName | capitalize }} </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ (data.companyAddress1 + ', ') | upperCase }}
              {{ data.companyNumber | upperCase }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ (data.companyCity + ', ') | upperCase }}
              {{ (data.companyState + ', ') | upperCase }} {{ data.companyZip }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ $t('email') | upperCase }} :
              {{ data.companyEmail | upperCase }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ $t('phone') | upperCase }} :
              {{ data.companyPhone | upperCase }}
            </span>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
        <vs-row vs-justify="center" class="f-14">
          <vs-col vs-type="flex" vs-w="12">
            <span class="f-bold"> {{ data.vendorName | capitalize }} </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ (data.vendorAddress1 + ', ') | upperCase }}
              {{ data.vendorNumber | upperCase }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12">
            <span>
              {{ (data.vendorCity + ', ') | upperCase }}
              {{ (data.vendorState + ', ') | upperCase }} {{ data.vendorZip }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
            <span> RFC : </span>
          </vs-col>
          <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
            <span>{{ data.RFC | upperCase }} </span>
          </vs-col>
          <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
            <span > {{ $t('email') | upperCase }} : </span>
          </vs-col>
          <vs-col vs-type="flex" vs-xs="12" vs-sm="6" vs-lg="6">
            <p>
              {{ data.vendorEmail | upperCase }}
            </p>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="center" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-w="12">
        <vs-table class="mx-4 w-full" :data="items">
          <template slot="thead">
            <vs-th> # </vs-th>
            <vs-th>
              {{ $t('description') | capitalize }}
            </vs-th>
            <vs-th>
              {{ $t('quantity') | capitalize }}
            </vs-th>
            <vs-th class="text-right">
              {{ $t('unit_cost') | capitalize }}
            </vs-th>
            <vs-th class="text-right">
              {{ $t('total') | capitalize }}
            </vs-th>
          </template>
          <template>
            <vs-tr :key="indextr" v-for="(tr, indextr) in items">
              <vs-td>
                {{ items[indextr].ItemId }}
              </vs-td>
              <vs-td v-html="items[indextr].Description"> </vs-td>
              <vs-td>
                {{ formatNumber(items[indextr].Quantity) }}
              </vs-td>
              <vs-td class="text-right">
                $ {{ getFormatNumber(items[indextr].UnitPrice) }}
              </vs-td>
              <vs-td class="text-right">
                $ {{ getFormatNumber(items[indextr].Amount) }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="end" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3" class="text-right">
        <span class="f-bold">{{ $t('currency') }}: </span>
        <span class="f-bold">{{ data.currencyId }} </span>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="end" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3" class="text-right">
        <span class="f-bold">Sub-Total: </span>
        <span class="f-bold"> $ {{ getFormatNumber(data.subtotal) }}</span>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="end" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3">
        <span class="f-bold">Tax: </span>
        <span class="f-bold">$ {{ getFormatNumber(data.iva) }}</span>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="end" class="px-4 mb-4 f-14">
      <vs-col vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3">
        <strong class="f-bold">Total: </strong>
        <strong class="f-bold">$ {{ getFormatNumber(data.total) }}</strong>
      </vs-col>
    </vs-row>

    <vs-row vs-justify="center" class="px-4 mb-4">
      <vs-col>
        <log-detail :statusId="data.statusId" :logs="logs" />
        <div class="mt-4">
          <vs-row>
            <vs-col class="mx-4">
              <comments :data="comments" @send="addComment" />
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
  </qb-sidebar>
</template>
<script>
import QbSidebar from '@/views/qb-components/QbSidebar'
import QbStatusCard from '@/views/qb-components/QbStatusCard'
import dashboard from '@/http/requests/dashboard'
import Comments from '@/views/components/Comments.vue'
import LogDetail from '@/views/apps/accounting/components/LogDetail.vue'
import moment from 'moment'
import expense from '@/http/requests/expense'
import DashboardPdfViewer from '../components/pdf/DashboardPdfViewer.vue'
import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'
export default {
  name: 'expense-details',
  components: {
    QbSidebar,
    QbStatusCard,
    Comments,
    LogDetail,
    DashboardPdfViewer,
  },
  props: {
    expenseId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      name: 'sidebar-expense-details',
      loadings: {
        data: false,
        comments: false,
        logs: false,
        files: false,
      },
      data: {
        expenseId: '',
        folio: '',
        serie: '',
        total: '',
        currencyId: '',
        receivedDate: moment(),
        accountNumber: '',
        subtotal: '',
        paydate: moment(),
        iva: '',
        companyId: '',
        expenseDate: '',
        statusId: '',
        statusName: '',
        statusColor: '#626262',
        clientId: '',
        clientName: '',
        clientShortName: '',
        companyName: '',
        companyAddress1: '',
        companyAddress2: '',
        companyNumber: '',
        companyZip: '',
        companyCity: '',
        companyState: '',
        companyEmail: '',
        companyPhone: '',
        vendorId: '',
        vendorName: '',
        vendorRFC: '',
        vendorAddress1: '',
        vendorAddress2: '',
        vendorNumber: '',
        vendorCity: '',
        vendorState: '',
        vendorZip: '',
        vendorEmail: '',
        file: '',
        categoryId: '',
        categoryName: '',
        categoryColor: '',
      },
      comments: [],
      items: [],
      logs: [],
      files: [],
    }
  },
  methods: {
    open() {
      console.log('open')
      this.getData()
      this.getComments()
      this.getLogs()
      this.getFiles()
    },
    getFormatNumber(num = 0) {
      return this.formatNumber(parseFloat(num).toFixed(2), 2)
    },
    getData() {
      this.loadings.data = true
      dashboard
        .expenseDetails(this.expenseId)
        .then((response) => {
          this.data = response.data.expense
          this.items = response.data.items
          this.loadings.data = false
        })
        .catch((response) => {
          this.loadings.data = false
        })
    },
    addComment(text) {
      this.loadings.comments = true
      expense
        .addComment({ expense_id: this.expenseId, comment: text })
        .then((res) => {
          this.comments = [...this.comments, res.data.item]
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added',
          })
          this.loadings.comments = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.comments = false
        })
    },
    getComments() {
      this.loadings.comments = true
      expense
        .getComments({ expense_id: this.expenseId })
        .then((res) => {
          this.comments = res.data.comments
          this.loadings.comments = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.comments = false
        })
    },
    getLogs() {
      this.loadings.logs = true
      expense
        .getLogs(this.expenseId)
        .then((response) => {
          this.logs = response.data.logs
          this.loadings.logs = false
        })
        .catch((response) => {
          this.loadings.logs = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
    getFiles() {
      this.loadings.files = true
      expense
        .getFiles({ expense_id: this.expenseId })
        .then((res) => {
          this.files = res.data.files
          this.loadings.files = false
        })
        .catch((res) => {
          this.loadings.files = false
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
        })
    },
  },
  computed: {
    loading() {
      return (
        this.loadings.data === true ||
        this.loadings.comments === true ||
        this.loadings.logs === true
      )
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
